import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import SimpleListing from '@client/components/listings/simpleListing/SimpleListing';
import GuestbookEntry from '@client/components/guestbookEntry/GuestbookEntry';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import GuestbookForm from '@client/containers/guestbookForm/GuestbookForm';
import QuotationMark from '@client/components/guestbookEntry/quotationMark/QuotationMark';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import { selectFundraiserComment } from '@client/redux/fundraiser/fundraiserSelectors';
import { loadMoreFundraiserComments } from '@client/redux/fundraiser/fundraiserActions';
import { selectUserRoles } from '@client/redux/user';
import styles from './guestbook.scss';

class Guestbook extends PureComponent {
  constructor(props) {
    super(props);
  }

  loadMoreComments = () => {
    if (
      getIn(this.props.fundraiserComment, 'currentPage') <
      getIn(this.props.fundraiserComment, 'pageCount')
    ) {
      this.props.dispatch(
        loadMoreFundraiserComments(
          this.props.fundraiserSlug,
          getIn(this.props.fundraiserComment, 'currentPage') + 1
        )
      );
    }
  };

  render() {
    const {
      className,
      translations,
      isMyFundraiser,
      userRoles,
      fundraiserSlug,
      fundraiserId,
      fundraiserComment,
      dispatch,
    } = this.props;

    const isLoggedInAsAdmin =
      userRoles &&
      userRoles.includes(process.env.REACT_APP_AUTH0_ADMIN_ROLE_NAME);

    const listOfComments =
      fundraiserComment && getIn(fundraiserComment, 'results');
    const hasComments = listOfComments && listOfComments.size > 0;
    const hasMoreCommentsToLoad =
      getIn(this.props.fundraiserComment, 'currentPage') <
      getIn(this.props.fundraiserComment, 'pageCount');

    return (
      <>
        <div className={styles.guestbook}>
          {hasComments ? (
            <div className={classNames(styles.guestbookEntries, className)}>
              <SimpleListing
                list={listOfComments}
                ListItemComponent={GuestbookEntry}
                listItemProps={{
                  itemObjName: 'comment',
                  isMyFundraiser: isMyFundraiser,
                  isLoggedInAsAdmin: isLoggedInAsAdmin,
                  fundraiserId: fundraiserId,
                  deletePost: getIn(translations, 'deletePost'),
                  reportPost: getIn(translations, 'reportPost'),
                  hasBeenReported: getIn(translations, 'hasBeenReported'),
                }}
              />
              {hasMoreCommentsToLoad && (
                <span className={styles.loadMoreBtnContainer}>
                  <button
                    className={styleHelper.btnFlat}
                    onClick={this.loadMoreComments}
                  >
                    {getIn(translations, 'showMoreLabel')}
                  </button>
                </span>
              )}
            </div>
          ) : (
            <div className={styles.hasNoEntries}>
              <p>{getIn(translations, 'noGuestbookEntriesText')}</p>
              <QuotationMark />
            </div>
          )}
        </div>
        <GuestbookForm
          dispatch={dispatch}
          fundraiserSlug={fundraiserSlug}
          translations={{
            guestbookFormTitle: getIn(translations, 'guestbookFormTitle'),
            publishButtonLabel: getIn(translations, 'publishButtonLabel'),
          }}
        />
      </>
    );
  }
}

Guestbook.propTypes = {
  className: PropTypes.string,
  translations: ImmutablePropTypes.map,
  isMyFundraiser: PropTypes.bool,
  userRoles: PropTypes.object,
  fundraiserSlug: PropTypes.string,
  fundraiserId: PropTypes.string,
  fundraiserComment: ImmutablePropTypes.map,
  dispatch: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    fundraiserComment: selectFundraiserComment(state),
    userRoles: selectUserRoles(state),
  };
}

export default connect(mapStateToProps)(Guestbook);
